<template>
	<aside
		class="property"
		:class="{ 'shrink': !isVisible }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<div class="property-title">
				{{ $t('Timer Properties') }} - {{  label ? label.toUpperCase()  : 'Default Timer' }}
			</div>
			<button
				class="btn btn-default btn-sm btn-icon property-toggle"
				@click="isVisible = !isVisible">
				<i class="material-icons" v-if="isVisible">chevron_left</i>
				<i class="material-icons" v-else>chevron_right</i>
			</button>
		</div>
		<!-- <transition name="fade"> -->
			<div class="property-content pr-2" :class="{'pointer-events-none': isLocked || isActiveEdit  ? isLocked.is_locked || isActiveEdit : true}">
				<div class="form-group mb-0">
					<label class="text-primary">{{ $t('Timer Setting') }}</label>
					<div class="row">
						<div class="col-md-12 mb-3">
							<md-menu md-align-trigger md-direction="bottom-start" class="w-100">
								<div md-menu-trigger style="text-align: left">
									<custom-input
										align="left"
										class="form-control cur-p relative"
										:label="$t('Timer Setting')"
										:value="labelTimerSetting"
									/>
								</div>
								<md-menu-content id="scrolls-style">
									<md-menu-item class="item-property-rundown-timer" v-for="item in timerOptions" @click="changeTimerSetting(item)"
									:key="item.key">{{ item.label }}</md-menu-item>
								</md-menu-content>
							</md-menu>
						</div>
						<!-- <div class="col-md-12">
							<div class="d-flex flex-row" :class="{ 'upload-wrapper-error': !templateFile && !template && isRequired,
								'upload-wrapper': templateFile || template || !isRequired }">
								<div class="mt-4 mr-4 pointer"
								v-if="template && !template.img_path">
									<i class="material-icons">camera_alt</i>
								</div>
								<img class="mr-2 mt-4 template-long-thumbnail"
								v-if="template && template.img_path"
								:src="template.img_path"
								height="30"
								width="53.33" />
								<template v-if="!isUploading && !templateFile && !template" >
									<div class="text-left text-break w-75 file-name-media pointer"
										:class="{'template-center': !templateFile && !template}" @click="openTemplate">
										<p class="text-break">{{$t('Select template')}}</p>
									</div>
								</template>

								<div v-if="isUploading">
										{{ $t('Uploading') }} {{ progress }}%
								</div>

								<div class="text-left text-break w-75 mt-4 pointer"
									@click="playPreview()"
									v-if="templateFile && !isUploading">
									{{ templateFile.name }}
								</div>

								<div class="text-left text-break w-75 file-name-media pointer"
									@click="playPreview()"
									v-if="!templateFile && !isUploading && template">
									{{ template.name }}
								</div>

								<div class="vertical-line ml-4 mr-4" v-if="templateFile || template"></div>
								<div class="d-flex flex-column">
									<div class="mt-4 pointer" @click="openTemplate" v-if="templateFile || template"><i class="material-icons">folder</i></div>
								</div>
							</div>
						</div> -->
						<div class="col-md-12">
							<custom-input
								class="mb-3"
								align="left"
								:label="$t('Label')"
								:required="isRequired"
								@blur="save"
								@keyenter="save"
								v-model="label"
								:max="40"
								:restrictChar="true"
							/>
						</div>

						<div class="col-md-12">
							<custom-input
								class="mb-3"
								align="left"
								:label="$t('Message')"
								:required="isRequired"
								@blur="save"
								@keyenter="save"
								v-model="message"
								:max="1000"
							/>
						</div>
						<div class="form-group mb-3 col-md-6 mr-0 pr-1">
							<custom-input
								type="duration-timer"
								align="left"
								:label="timerSetting == 2 || timerSetting == 5 ? $t('Time'): $t('Duration')"
								:required="isRequired"
								:disabled="isPlayingLive"
								:maxTime="'86340'"
								:minTime="'0'"
								@blur="save"
								@keyenter="save"
								v-model="time"
							/>
						</div>

						<div class="form-group mb-3 col-md-6 mr-0 pl-1">
						<custom-input
							type="number"
							class="form-control"
							field="index"
							:label="$t('Layer')"
							:required="isRequired"
							:max="100"
							:index-duplicated="isIndexDuplicated"
							@blur="save"
							@keyenter="onInputEnter('layer', ...arguments)"
							v-model="layerIndex"
						/>

						</div>
						<!-- new pause timer  -->
						<div class="col-md-12" v-if="timerSetting == 6">
							<button type="button" class="btn btn-primary w-100 mb-3 " @click="togglePause" > {{ isPaused ? 'RESUME':'PAUSE' }} </button>
						</div>

						<!-- <div class="form-group mb-3 col-md-6">
							<button
								@click="testConnection()"
								class="md-primary mt-0 mb-3 mr-3" >
								{{ $t('test connection') }}
							</button>
						</div> -->
					</div>
				</div>
				<div class="form-group mt-3">
					<label class="text-primary">{{ $t('Timer Style') }}</label>
					<div class="row row-thin">
						<!-- color -->
						<div class="col-md-6 mr-0 pr-1">
							<!-- Color -->
							<custom-input
								class="mb-3"
								type="color"
								align="left"
								:label="$t('Color')"
								:required="isRequired"
								@input="onKeywordChange"
								v-model="color"
								@blur="save"
								@keyenter="save"
							/>
						</div>
						<!-- BG color -->
						<div class="col-md-6 pl-1">
							<!-- BG Color -->
							<custom-input
								class="mb-3"
								type="color"
								align="left"
								picker-position="right"
								:label="$t('BG Color')"
								:required="isRequired"
								@input="onKeywordChange"
								v-model="backgroundColor"
								@blur="save"
								@keyenter="save"
							/>
						</div>
						<div class="col-md-6 mb-3 mr-0 pr-1">
							<md-menu md-align-trigger md-direction="bottom-start" :md-active.sync="isToggleFont">
								<div md-menu-trigger class="mw-161px">
									<custom-input
										v-if="fontStyle >= 0 && fontStyle !== ''"
										type="selectSearch"
										class="form-control cur-p relative"
										:label="$t('Font')"
										:value="labelFont"
										@remove="removeFont()"
										:showClose="true"
										:align="'left'"
									/>
									<div @click.stop="toggleFont">
										<custom-input
											v-click-outside="resetFont"
											v-if="fontStyle === ''"
											type="selectSearchEmpty"
											class="form-control cur-p relative capitalize"
											:label="$t('Font')"
											v-model="searchFont"
											:showClose="false"
											:align="'left'"
										/>
									</div>
								</div>
								<md-menu-content id="scrolls-style" class="assets-item-wrapper-list ">
									<md-menu-item class="assets-item-wrapper-list item-property-rundown" v-for="item in filteredFont" @click="fontStyle = parseInt(item.key)"
										:key="item.key">{{item.label}}
									</md-menu-item>
									<md-menu-item v-if="filteredFont.length <= 0" class="assets-item-wrapper-list item-property-rundown">
										Not available
									</md-menu-item>
								</md-menu-content>
							</md-menu>
						</div>
						<div class="form-group mb-3 col-md-6">
							<md-switch
								class="md-primary mt-0 mb-3 mr-3"
								@change="save"
								v-model="showBackground">
								<div class="mt-1px">{{ $t('Show Background') }}</div>
							</md-switch>
						</div>
					</div>
				</div>

				<div class="form-group">
					<position-settings
						class="mb-3"
						:width.sync="width"
						:height.sync="height"
						:position.sync="position"
						:x.sync="x"
						:y.sync="y"
						:isRatio.sync="isRatio"
						@reset="resetSizePosition"
						@change="onKeywordChange"
						@keyenter="save"
					/>
				</div>
				<!-- on complete label -->
				<div class="mt-2">
						<div class="d-flex justify-content-between">
							<div>
								<label class="text-primary">{{ $t('On Complete') }}</label>
							</div>
							<!-- <div class="ml-0 pl-0">
								<md-switch
									class="md-primary mt-0 mb-2 mr-0"
									v-model="isParent"
									@change="saveMedia()">
								</md-switch>
							</div> -->
						</div>
					</div>
					<!-- on complete controller -->
					<div class="pr-0 pl-0">
						<md-menu
							:md-active.sync="isOnComplete"
							class="h-fc col-md-12 pr-0 pl-0"
							md-size="small"
							md-direction="top-start"
							md-align-trigger>
							<div v-if="selectedOnComplete"
								class="form-control cur-p relative mb-4"
								md-menu-trigger>
								<item-option
									:item="selectedOnComplete"
									v-if="selectedOnComplete"
								/>
								<div class="text-right">
									<div @click.stop="removeOnComplete" class="modal-close-assets absolute delete-complete-add">
										<i class="material-icons">cancel</i>
									</div>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control mb-4"
									:placeholder="$t('Stop (default)')"
									@input="onKeywordChange"
									v-model="keywordSearchOnComplete"
									@click.stop="toggleOnComplete"
								/>
								<item-option
									:item="selectedOnComplete"
									v-if="selectedOnComplete"
								/>
							</div>
							<md-menu-content id="scrolls-style"
							:class="{'macro-content-wrapper-list': filteredParent.length > 6, 'assets-wrapper-list-empty': filteredParent.length === 0,
								'assets-wrapper-list-1': filteredParent.length === 1, 'assets-wrapper-list-2': filteredParent.length === 2,
								'assets-wrapper-list-3': filteredParent.length === 3, 'assets-wrapper-list-4': filteredParent.length === 4,
								'assets-wrapper-list-5': filteredParent.length === 5, 'assets-wrapper-list-6': filteredParent.length === 6,
								}"
								>
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in filteredParent"
									:key="rundownItem.id"
									@click="selectOnComplete(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
				<!-- parent controller  -->
				<div class="mt-2">
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Parent Controller') }}</label>
						</div>
						<div class="ml-0 pl-0">
							<md-switch class="md-primary mt-0 mb-2 mr-0" @change="save()" v-model="isParent">
							</md-switch>
						</div>
					</div>
				</div>
				<div class="d-flex select ">
						<!-- <div class="select w-75">
							<div class="mb-2 mh-60px mr-4">
								<multiselect class="select-input" v-model="parentItem"
									select-label="" deselect-label="Remove" track-by="id" label="name"
									openDirection="bottom" :optionsLimit="10" :optionHeight="100"
									placeholder="Search or Select Parent Item" :options="filteredParent" @input="save()"
									:searchable="true" :allow-empty="true" :show-labels="true" :selectedLabel="''">
									<span class="arrow-multiselect" slot="caret">
										<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
									</span>
									<template slot="singleLabel"
										slot-scope="{ option }">{{ option.name }}</template>
								</multiselect>
							</div>
						</div> -->
						<!-- new dropdown select assets -->
						<md-menu
							:md-active.sync="isToggleParent"
							class="h-fc mr-2"
							md-size="small"
							md-direction="bottom-start"
							md-align-trigger>
							<div v-if="selectedParent"
								class="form-control cur-p relative w-230px"
								md-menu-trigger>
								<item-option
									:item="selectedParent"
									v-if="selectedParent"
								/>
								<div @click.stop="removeParent" class="modal-close-assets absolute delete-assets-add">
									<i class="material-icons">cancel</i>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control w-230px"
									:placeholder="$t('Search or Select Parent Item')"
									@input="onKeywordChange"
									v-model="keywordSearchParent"
									@click.stop="toggleParent"
								/>
								<item-option
									:item="selectedParent"
									v-if="selectedParent"
								/>
							</div>
							<md-menu-content id="scrolls-style" class="macro-content-wrapper-list">
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in filteredParent"
									:key="rundownItem.id"
									@click="selectParent(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
						<!-- delay -->
						<div class="select">
							<custom-input
								class="form-input mb-3"
								type="number"
								:label="$t('Delay')"
								:min="-15000"
								:max="15000"
								:step="100"
								:suffix="'ms'"
								v-model="childOrder"
								@input="onKeywordChange"
								@keyenter="onInputEnter('delay', ...arguments)"
								@blur="save"
								:allowNegative="true"
							/>
							<!-- <div class="mb-2 mh-60px">
								<multiselect class="select-input" v-model="childOrder" select-label=""
									track-by="id" label="name" openDirection="bottom" placeholder="No Delay" :options="delayList" @input="save()"
									:searchable="true" :allow-empty="true" :show-labels="false">
									<span class="arrow-multiselect" slot="caret">
										<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
									</span>
									<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
								</multiselect>
							</div> -->
						</div>
				</div>
			</div>
		<!-- </transition> -->
	</aside>
</template>

<script>
import { mapGetters } from 'vuex';
// import Multiselect from 'vue-multiselect';
import ClickOutside from 'vue-click-outside';
import ItemOption from '@/components/ItemOption.vue';
import { delay } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import CustomInput from '@/components/CustomInput.vue';
import PositionSettings from '@/components/PositionSettings.vue';
import {
	fontOptions,
	delayList,
	timerOptions,
	timerTemplate,
} from '@/lib/statics';

// import fileApi from '@/api/file';
export default {
	name: 'TimerProperty',
	components: {
		CustomInput,
		PositionSettings,
		// Multiselect,
		ItemOption,
	},
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		template: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	sockets: {
		timer_toggle_pause(data) {
			const { status } = data;
			if (this.timerSetting && this.timerSetting === 6) {
				this.isPaused = JSON.parse(status);
			}
		},
	},
	data() {
		return {
			timerOptions,
			timerTemplate,
			timerSetting: '',
			templateFile: '',
			templates: [],
			selectedTemplate: null,
			isLoading: false,
			label: '',
			message: '',
			time: '00:00:00',
			fontColor: '',
			backgroundColor: '',
			layerIndex: '',
			width: 0,
			height: 0,
			position: '',
			x: 0,
			y: 0,
			type: 'timer',
			progress: 0,
			isUploading: false,
			isSaving: false,
			isVisible: true,
			isshowColorPickerFontColor: false,
			isshowColorPickerBgColor: false,
			isRequired: false,
			isRatio: true,
			showBackground: false,
			color: '',
			isActiveEdit: false,
			isParent: false,
			parentItem: null,
			delayList,
			childOrder: 0,
			fontStyle: 0,
			fontOptions,
			searchFont: '',
			selectedParent: null,
			selectedOnComplete: null,
			keywordSearchParent: '',
			keywordSearchOnComplete: '',
			isToggleParent: false,
			isOnComplete: false,
			isToggleFont: false,
			isPaused: false,
			tmpTimerSetting: null,
		};
	},
	directives: {
		ClickOutside,
	},
	methods: {
		changeTimerSetting(item) {
			if (item.key === 2 && this.timerSetting !== 2 && this.time === '00:05:00') {
				const currentTime = this.stringToSecondsTimer(this.time);
				this.time = this.secondToString(currentTime + 1800);
			}
			if (item.key === 5) {
				const date = new Date();
				const scnd = date.getSeconds();
				const minutes = date.getMinutes();
				const hour = date.getHours();
				const secondTotal = ((hour) * 60 * 60) + ((minutes) * 60) + (scnd);
				this.time = this.secondToString(secondTotal);
			}
			this.timerSetting = item.key;
			this.selectedTemplate = timerTemplate.find(({ id }) => id === this.timerSetting);
			this.save();
			// this.playPreview(true);
		},
		secondToString(value) {
			const secNum = parseInt(value); // don't forget the second param
			let hours = Math.floor(secNum / 3600);
			let minutes = Math.floor((secNum - (hours * 3600)) / 60);
			let seconds = secNum - (hours * 3600) - (minutes * 60);
			if (hours < 10) { hours = `0${hours}`; }
			if (minutes < 10) { minutes = `0${minutes}`; }
			if (seconds < 10) { seconds = `0${seconds}`; }
			return `${hours}:${minutes}:${seconds}`;
		},
		stringToSecondsTimer(sec) {
			const hms = sec; // your input string
			const a = hms.split(':'); // split it at the colons
			// minutes are worth 60 seconds. Hours are worth 60 minutes.
			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			return seconds;
		},
		playPreview(reFetch = false) {
			if (this.data.is_Locked) return; // Disable when ed
			const id = this.data.id;
			const status = 'preview';
			// eslint-disable-next-line no-unused-vars
			const callback = (response) => {
				const item = response.data;
				const currentItem = item.find(({ id }) => id === this.data.id);
				if (reFetch) {
					if (currentItem && !currentItem.is_play_preview) {
						delay(() => {
							this.playPreview();
						}, 1000);
					}
				}
			};
			const errorCallback = () => {
			};
			const userActivateAllItem = this.userSettings && this.userSettings.is_enable_all_preview ? this.userSettings.is_enable_all_preview : false;
			const params = {
				isAllItem: userActivateAllItem,
			};
			rundownItemsApi.togglePlay(id, status, params, callback, errorCallback);
		},
		togglePause() {
			this.isPaused = !this.isPaused;
			const callback = () => {
				this.save();
			};
			const errorCallback = (err) => {
				console.log(err);
			};
			rundownItemsApi.togglePauseTimer(this.rundown.slug, this.data.id, this.isPaused, callback, errorCallback);
		},
		toggleFont() {
			this.isToggleFont = true;
		},
		toggleParent() {
			this.isToggleParent = true;
		},
		toggleOnComplete() {
			this.isOnComplete = true;
		},
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		initData() {
			this.isVisible = true;
			this.reset();
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				this.label = this.data.name;
				this.layerIndex = this.data.layer_index;
				if (content) {
					if (content.template) {
						// eslint-disable-next-line eqeqeq
						this.selectedTemplate = timerTemplate.find(({ id }) => id === content.timerSetting);
						// this.$emit('setTemplate', this.selectedTemplate);
						// this.lottiedatachange(this.selectedTemplate);
					}
					this.message = content.message;
					if (content.time.length > 5) {
						this.time = content.time;
					} else {
						this.time = '00:00:00';
						this.save();
					}
					this.color = content.color;
					this.backgroundColor = content.backgroundColor;
					this.fontColor = content.fontColor;
					this.backgroundColor = content.backgroundColor;
					this.width = content.width;
					this.height = content.height;
					this.position = content.position;
					this.showBackground = content.showBackground;
					this.isRatio = content.isRatio;
					this.x = content.x;
					this.y = content.y;
					this.isParent = content.isParent || false;
					this.fontStyle = content.fontStyle;
					this.timerSetting = content.timerSetting;
					this.isPaused = content.isPaused;
					// this.parentItem = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedParent = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.childOrder = content.childOrder || 0;
				}
			}
		},
		reset() {
			// this.label = '';
			this.message = '';
			this.time = '00:00:00';
			this.color = '#ffffff';
			// this.backgroundColor = '';
			this.selectedTemplate = '';
			this.fontColor = '#000000';
			this.backgroundColor = '#ffffff';
			this.layerIndex = 0;
			this.width = 1920;
			this.height = 1080;
			this.position = 'default';
			this.x = 0;
			this.y = 0;
			this.fontStyle = 0;
			this.isPaused = false;
			if (this.timerSetting) {
				// eslint-disable-next-line eqeqeq
				this.selectedTemplate = timerTemplate.find(({ id }) => id === this.timerSetting);
			}
		},

		save() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
				// this.playPreview(true);
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			if (this.data) {
				rundownItemsApi.update(this.data.id, this.params, callback, errorCallback);
			} else {
				rundownItemsApi.create(this.params, callback, errorCallback);
			}
		},

		onKeywordChange() {
			delay(() => {
				this.save();
			}, 1200);
		},
		openTemplate() {
			this.$emit('browse');
		},
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.layerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		resetSizePosition() {
			this.x = 0;
			this.y = 0;
			this.position = 'default';
			this.width = 1920;
			this.height = 1080;
			this.save();
		},
		selectParent(item) {
			this.selectedParent = item;
			this.keywordSearchParent = '';
			this.save();
		},
		removeParent() {
			this.selectedParent = null;
			this.keywordSearchParent = '';
			this.save();
		},
		selectOnComplete(item) {
			this.selectedOnComplete = item;
			this.keywordSearchOnComplete = '';
			this.save();
		},
		removeOnComplete() {
			this.selectedOnComplete = null;
			this.keywordSearchOnComplete = '';
			this.save();
		},
		onInputEnter(props, value) {
			if (props === 'layer') this.layerIndex = value;
			if (props === 'delay') this.childOrder = value;
			this.save();
		},
		removeFont() {
			this.fontStyle = '';
		},
		resetFont() {
			this.searchFont = '';
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		filteredParent() {
			const filteredParent = this.items.filter(item => item.id !== this.data.id);
			let finalResult = filteredParent.filter(item => item.type !== 'separator');
			if (this.keywordSearchParent) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchParent.toUpperCase()));
				return finalResult;
			}
			if (this.keywordSearchOnComplete) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchOnComplete.toUpperCase()));
				return finalResult;
			}
			return finalResult;
		},
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		isPlayingLive() {
			return this.data && !!this.data.is_play_live && this.data.is_play_live === 1;
		},
		params() {
			// const parentItemId = this.parentItem && this.parentItem.id ? this.parentItem.id : null;

			const parentItemId = this.selectedParent && this.selectedParent.id ? this.selectedParent.id : null;
			const onCompleteItemId = this.selectedOnComplete && this.selectedOnComplete.id ? this.selectedOnComplete.id : null;
			const content = {
				message: this.message,
				time: this.time,
				color: this.color,
				backgroundColor: this.backgroundColor,
				template: this.selectedTemplate,
				fontColor: this.fontColor,
				layerIndex: this.layerIndex,
				width: this.width,
				height: this.height,
				position: this.position,
				isRatio: this.isRatio,
				showBackground: this.showBackground,
				x: this.x,
				y: this.y,
				isParent: this.isParent,
				parentItem: parentItemId,
				onCompleteItem: onCompleteItemId,
				childOrder: this.childOrder,
				fontStyle: this.fontStyle,
				timerSetting: this.timerSetting,
				isPaused: this.isPaused,
			};
			const contentString = JSON.stringify(content);
			const name = this.label !== '' ? this.label : 'Default Timer';
			const params = {
				name,
				type: this.type,
				content: contentString,
				layer_index: this.layerIndex,
				rundown_id: this.rundownId,
				// status: 1,
				// is_play_live: 0,
				// is_play_preview: 0,
				// is_shy: 0,
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.layerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		labelFont() {
			let content = this.data.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			if (content && content.fontStyle >= 0) {
				const index = this.fontOptions.findIndex(({ key }) => key === JSON.stringify(content.fontStyle));
				if (index !== -1) return this.fontOptions[index].label;
			}
			return this.fontOptions[0].label;
		},
		labelTimerSetting() {
			let content = this.data.content;

			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			if (content && content.timerSetting) {
				const index = this.timerOptions.findIndex(({ key }) => key === content.timerSetting);
				if (index !== -1) {
					return this.timerOptions[index].label;
				}
			}
			return '';
		},
		filteredFont() {
			if (this.searchFont) {
				return this.fontOptions.filter(item => item.label.toLowerCase().includes(this.searchFont));
			}
			return this.fontOptions;
		},
		content() {
			return this.data.content && this.data.content !== ''
				? JSON.parse(this.data.content) : {};
		},
	},
	watch: {
		fontStyle() {
			this.searchFont = '';
			this.save();
		},
		// template() {
		// 	if (this.template) {
		// 		if (this.selectedTemplate !== this.template) {
		// 			this.selectedTemplate = this.template;
		// 			this.save();
		// 		}
		// 	}
		// },
		data() {
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				this.label = this.data.name;
				this.layerIndex = this.data.layer_index;
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				} else {
					this.isActiveEdit = false;
				}
				if (content) {
					if (content.timerSetting) {
						this.selectedTemplate = timerTemplate.find(({ id }) => id === content.timerSetting);
					}
					this.message = content.message;
					this.time = content.time;
					this.color = content.color;
					this.fontColor = content.fontColor;
					this.backgroundColor = content.backgroundColor;
					this.width = content.width;
					this.height = content.height;
					this.position = content.position;
					this.showBackground = content.showBackground;
					this.isRatio = content.isRatio;
					this.x = content.x;
					this.y = content.y;
					this.isParent = content.isParent;
					this.timerSetting = content.timerSetting;
					this.isPaused = content.isPaused;
					// this.parentItem = this.filteredItems.find(item => item.id === content.parentItem) || '';
					this.selectedParent = this.filteredItems.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.fontStyle = content.fontStyle;
					this.childOrder = content.childOrder;
				}
			}
		},
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		this.isRequired = false;
		this.$nextTick(() => {
			this.initData();
		});
		this.isLoading = true;
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 400);
	},
};
</script>
